import React from 'react';
import { useAuth } from '../context/AuthContext';
import PageFooter from '../components/PageFooter';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  const { user } = useAuth();

  const stats = [
    { label: 'Total Workflows', value: '24', change: '+3 this week', icon: '📊' },
    { label: 'Active Executions', value: '5', change: '2 running now', icon: '▶️' },
    { label: 'Available Agents', value: '6', change: 'All active', icon: '🤖' },
    { label: 'Success Rate', value: '94%', change: '+2% this month', icon: '✅' },
  ];

  const recentExecutions = [
    { name: 'SDLC Complete Pipeline', status: 'completed', time: '10 mins ago' },
    { name: 'Code Generation Workflow', status: 'running', time: '2 mins ago' },
    { name: 'Documentation Generator', status: 'completed', time: '1 hour ago' },
  ];

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <div>
          <h1>Welcome back, {user?.username}!</h1>
          <p>Here's what's happening with your workflows today</p>
        </div>
      </div>

      <div className="stats-grid">
        {stats.map((stat, idx) => (
          <div key={idx} className="stat-card">
            <div className="stat-icon">{stat.icon}</div>
            <div className="stat-content">
              <div className="stat-value">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
              <div className="stat-change">{stat.change}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h2>Recent Executions</h2>
          <div className="executions-list">
            {recentExecutions.map((exec, idx) => (
              <div key={idx} className="execution-item">
                <div className="execution-info">
                  <div className="execution-name">{exec.name}</div>
                  <div className="execution-time">{exec.time}</div>
                </div>
                <span className={`status-pill ${exec.status}`}>{exec.status}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="dashboard-card">
          <h2>Quick Actions</h2>
          <div className="quick-actions">
            <button className="action-btn">
              <span className="action-icon">➕</span>
              <span>Create New Workflow</span>
            </button>
            <button className="action-btn">
              <span className="action-icon">🤖</span>
              <span>Browse Agents</span>
            </button>
            <button className="action-btn">
              <span className="action-icon">▶️</span>
              <span>View Executions</span>
            </button>
            {user?.role === 'admin' && (
              <button className="action-btn">
                <span className="action-icon">⚙️</span>
                <span>System Settings</span>
              </button>
            )}
          </div>
        </div>

        <div className="dashboard-card">
          <h2>System Health</h2>
          <div className="health-metrics">
            <div className="health-item">
              <span className="health-label">API Gateway</span>
              <span className="health-status healthy">Healthy</span>
            </div>
            <div className="health-item">
              <span className="health-label">Workflow Engine</span>
              <span className="health-status healthy">Healthy</span>
            </div>
            <div className="health-item">
              <span className="health-label">Database</span>
              <span className="health-status healthy">Healthy</span>
            </div>
            <div className="health-item">
              <span className="health-label">Agent Registry</span>
              <span className="health-status healthy">Healthy</span>
            </div>
          </div>
        </div>

        <div className="dashboard-card">
          <h2>Popular Agents</h2>
          <div className="popular-agents">
            <div className="agent-item">
              <span className="agent-name">Code Generator Agent</span>
              <span className="agent-uses">2,134 uses</span>
            </div>
            <div className="agent-item">
              <span className="agent-name">Code Review Agent</span>
              <span className="agent-uses">1,876 uses</span>
            </div>
            <div className="agent-item">
              <span className="agent-name">BRD Generator Agent</span>
              <span className="agent-uses">1,247 uses</span>
            </div>
          </div>
        </div>
      </div>
      <PageFooter />
    </div>
  );
};

export default Dashboard;

